import PlannerFilterFormFieldComp from "Pages/PlannerView/PlannerFilterFormFieldComp";
import { Badge, Button, Form, Space, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import {
  USER_ROLE_ACCESS,
  academicPhase,
} from "utilFunctions/Constants/Constants";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { removeEmptyFields } from "utilFunctions/helperFunctions/HelperFunction";
import DrawerAntdComponent from "utilFunctions/shared/AntdSharedComponents/DrawerAntdComponent";
import HeadersComponent from "utilFunctions/shared/AntdSharedComponents/HeadersComponent";
interface PlannerHeaderAntdIF {
  filterState: any;
  handleAppliedFilter: any;
  setFilterState: any;
  open: any;
  setOpen: any;
  userInfo: any;
  isEDPDepartment: any;
  chipShow: any;
  setChipShow: any;
  stream: any;
  acadYears: any;
  classes: any;
  docTypes: any;
  subjects: any;
  setPagination: any;
}
const PlannerHeaderAntd = ({
  filterState,
  handleAppliedFilter,
  setFilterState,
  open,
  setOpen,
  userInfo,
  isEDPDepartment,
  chipShow,
  setChipShow,
  stream,
  classes,
  subjects,
  acadYears,
  setPagination,
}: PlannerHeaderAntdIF) => {
  const { screen }: any = useWindowSize();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const backButtonHandler = () => {
    console.log("object");
  };
  const defaultvalue: any = {
    streamList: userInfo?.userStreams[0]?.value,
    acadYearList: null,
    docTypeList: null,
    classList: null,
    phaseList: null,
    subjectList: null,
  };

  const newFilterState = JSON.parse(JSON.stringify(chipShow));
  const chipsFields = newFilterState && newFilterState.chipFieldName;
  delete newFilterState.chipFieldName;
  const filterLength = Object.values(newFilterState).filter(
    (ele) => ele != null
  ).length;
  console.log("newFilterState", chipsFields, chipShow);
  const checkIfFilterApplied = (filterSTATE: any, defaultVALUE: any) => {
    let retValue = false;
    Object.keys(defaultVALUE).map((el) => {
      if (defaultVALUE[el] != filterSTATE[el]) {
        retValue = true;
      }
    });
    return retValue;
  };
  const handleResetSearchfaculty = () => {
    form.resetFields();
    setPagination({
      pageSize: 10,
      total: 10,
      pageSizeOptions: ["10", "50"],
      showSizeChanger: true,
      current: 1,
      sortField: "updatedAt",
      sortOrder: "DESC",
    });
    const filterState = {
      streamList: userInfo?.userStreams[0]?.value,
      acadYearList: null,
      docTypeList: null,
      classList: null,
      phaseList: null,
      subjectList: null,
    };
    setFilterState(filterState);
    handleAppliedFilter(filterState);
    setChipShow({
      streamList: userInfo?.userStreams[0]?.value,
      chipFieldName: {
        streamList: userInfo?.userStreams[0]?.value,
      },
    });
  };
  const onChange = (name: string, val: any) => {
    setFilterState((prevState: any) => ({
      ...prevState,
      [name]: val,
      chipFieldName: {
        ...filterState.chipFieldName,
        [name]: val,
      },
    }));
  };
  const getFieldsNameFromArr = (ele: any, item: string, arr: any) => {
    if (typeof chipsFields[ele] != "object") {
      const findItem = arr?.find((ele: any) => ele.value == item)?.label;
      return findItem;
    } else {
      const findItem = arr
        .filter((ele: any) => item.includes(ele.value))
        .map((el: any) => el.label)
        ?.join(", ");
      return findItem;
    }
  };
  const returnName = (ele: any, chipsFields: any) => {
    if (ele === "classList") {
      return getFieldsNameFromArr(ele, chipsFields[ele], classes);
    } else if (ele === "phaseList") {
      return getFieldsNameFromArr(ele, chipsFields[ele], academicPhase);
    } else if (ele === "subjectList") {
      return getFieldsNameFromArr(ele, chipsFields[ele], subjects);
    } else if (ele === "streamList") {
      return getFieldsNameFromArr(ele, chipsFields[ele], stream);
    } else if (ele === "acadYearList") {
      return getFieldsNameFromArr(ele, chipsFields[ele], acadYears);
    }
    return null;
  };
  const Reset = () => <Button onClick={handleResetSearchfaculty}>Reset</Button>;
  return (
    <>
      <DrawerAntdComponent
        title={"Filters"}
        open={open}
        setOpen={setOpen}
        width={450}
        footer={
          <>
            <Space className="d-flex justify-content-start">
              <Button
                type="primary"
                onClick={() => {
                  setChipShow(filterState);
                  handleAppliedFilter(filterState);
                }}
                className={"m-0"}
              >
                Apply
              </Button>
              {filterLength > 0 &&
              checkIfFilterApplied(filterState, defaultvalue) ? (
                <Reset />
              ) : null}
              <Button onClick={() => setOpen(false)}>Close</Button>
            </Space>
          </>
        }
      >
        <Form layout={"vertical"} className="w-100" size="middle">
          <PlannerFilterFormFieldComp
            filterState={filterState}
            form={form}
            onChange={onChange}
            isRequired={false}
          ></PlannerFilterFormFieldComp>
        </Form>
      </DrawerAntdComponent>
      <HeadersComponent
        cardTitle={"Planners"}
        backButtonHandler={backButtonHandler}
      >
        <div className="d-flex gap-2 align-items-center">
          {filterLength > 0 && ["xxl", "xl", "lg"].includes(screen) && (
            <div
              style={{ width: "400px", overflow: "auto", display: "flex" }}
              className={
                filterLength > 3
                  ? "d-flex flex-row justify-content-start align-items-center chipContainer p-0"
                  : "d-flex flex-row justify-content-end align-items-end chipContainer p-0"
              }
            >
              {newFilterState &&
                Object.keys(removeEmptyFields(newFilterState)).map(
                  (ele: any) => {
                    return (
                      <Tag
                        style={{
                          textAlign: "center",
                          textTransform: "capitalize",
                        }}
                        key={ele}
                      >
                        {returnName(ele, newFilterState)}
                      </Tag>
                    );
                  }
                )}
            </div>
          )}
          <Badge count={filterLength ? filterLength : 0}>
            <Button
              type="primary"
              onClick={() => {
                setOpen(true);
              }}
            >
              Filters
            </Button>
          </Badge>
          {filterLength > 0 &&
          checkIfFilterApplied(filterState, defaultvalue) ? (
            <Reset />
          ) : null}
          {userInfo &&
          USER_ROLE_ACCESS.includes(userInfo.fexRole) &&
          isEDPDepartment ? (
            <div className="pl-2">
              <Button
                type="primary"
                onClick={() => {
                  navigate("/admin/planner/uploadPlanner", {
                    replace: true,
                  });
                }}
              >
                Upload
              </Button>
            </div>
          ) : null}
        </div>
      </HeadersComponent>
    </>
  );
};

export default PlannerHeaderAntd;
